<template>
  <div class="search">
    <md-field
      :md-inline="!chips"
      :md-counter="chips"
      class="md-chips"
      :class="{'md-has-value': chips && stateStore.length > 0, 'md-invalid': errors.has('item')}">
      <label>{{label}}</label>
      <md-chip
        v-if="chips"
        v-for="(value, index) in stateStore"
        :key="index"
        @md-delete="removeItem(value)"
        :md-disabled="disabled"
        :md-deletable="!disabled">
        {{value}}
      </md-chip>
      <md-input
        class="select-small"
        :class="{'hide': !multiple}"
        name="item"
        v-validate="veeObj"
        data-vv-validate-on="none"
        type="text"
        autocomplete="off"
        v-model="item"
        maxlength="250"
        :disabled="disabled"
        :placeholder="stateStore.length === 0 ? placeholder : ''"
        id="item"
        @keydown.tab.capture.prevent.stop="insertItem()"
        @keydown.enter="insertItem()"
        @keydown.delete="deleteLast()"
        @keydown.esc.capture.prevent.stop="cleanListDefaultLoaded()"
        @blur="validateEmail()"
        @keydown.up="keyUp()"
        @keydown.down="keyDown()">
      </md-input>
      <span class="md-error" v-if="errors.firstByRule('item','required')">{{ $t('requiredWarning') }}</span>
      <span class="md-error" v-else-if="errors.firstByRule('item','regex')">{{ $t(regexErroMsg) }}</span>
      <span class="md-error" v-else>{{ $t('invalidWarning') }}</span>

      <div v-if="searchLoading" class="lds-ring loading-small">
        <div></div><div></div><div></div><div></div>
      </div>
    </md-field>
    <div class="results-container " :class="{'has-result': items.length !== 0, 'results-container-chips': chips}">
      <div v-if="items.length !== 0" @mouseover="mouseOver(index)" v-for="(item, index) in items" :key="index">
        <component :is="currentSearchComponent" :item="item"
                   @click.native="hit(item)"
                   :isActive="index === current">
        </component>
      </div>
    </div>
  </div>
</template>
<script>
import utils from '@/utils/utils.js'

export default {
  name: 'search',
  inject: ['$validator'],
  data: () => {
    return {
      limit: 50,
      items: [],
      item: '',
      selected: null,
      timeout: 0,
      parentContainer: null,
      searchButton: null,
      currentSearchComponent: 'usersItem',
      current: -1,
      searchLoading: false,
      idTimeOut: 0,
    }
  },
  props: {
    debounce: {
      type: Number,
      default: 1E3
    },
    fetch: {
      type: Function
    },
    pushStore: {
      type: Function
    },
    removeStore: {
      type: Function
    },
    stateStore: {
      type: Array,
      default: () => []
    },
    minChars: {
      type: Number,
      default: 1
    },
    placeholder: {
      type: String
    },
    label: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    chips: {
      type: Boolean,
      default: true
    },
    activeAutoComplete: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: true
    },
    validateObj: {
      type: Object,
      default: {}
    },
    regexErroMsg: {
      type: String,
      default: null
    }
  },
  watch: {
    item: function (newVal) {
      if (this.activeAutoComplete) {
        this.debounceUpdate()
        this.current = 0
      }
    }
  },
  methods: {
    debounceUpdate () {
      this.items = []
      if (this.item !== undefined && this.item.length >= this.minChars) {
        this.loading = true
      }
      const SearchBookings = utils.debounce(this.makeFetchRequest, false, this.debounce, this.idTimeOut)
      this.idTimeOut = SearchBookings
    },
    cleanListDefaultLoaded () {
      utils.debounce(this.reset, false, 200)
    },
    hit (item) {
      if (item) {
        this.item = item.item
        this.insertItem()
      }
      document.getElementById('item').focus()
    },
    makeFetchRequest () {
      this.searchLoading = true
      return this.fetch({query: this.item})
        .then((response) => {
          if (response.length !== 0) {
            this.errors.clear()
          }
          this.searchLoading = false
          this.items = response
        })
    },
    reset () {
      this.errors.clear()
      this.items = []
      this.item = ''
      this.current = 0
    },
    keyUp () {
      if (this.current > 0) {
        this.current--
      }
    },
    keyDown () {
      if (this.current < this.items.length - 1) {
        this.current++
      }
    },
    mouseOver (index) {
      this.current = index
    },
    validateEmail () {
      if (this.items.length === 0) {
        if (this.item !== undefined) {
          this.$validator.validate('item').then((result) => {
            if (result) {
              if (!(this.item === '' || this.item === null)) {
                this.pushStore(this.item)
                this.reset()
              }
            }
          })
        }
      }
    },
    insertItem () {
      this.validateEmail()
      if (this.items.length !== 0) {
        this.pushStore(this.items[this.current])
        this.cleanListDefaultLoaded()
      }
    },
    async removeItem (chips) {
      await this.removeStore(this.stateStore.indexOf(chips))
      setTimeout(() => {
        document.getElementById('item').focus()
      }, 300)
    },
    deleteLast () {
      if (this.item === '' || this.item === null) {
        this.removeStore(-1)
      }
    },
  },
  computed: {
    veeObj: function () {
      if(this.validateObj.required) {
        let _validateObj = JSON.parse(JSON.stringify(this.validateObj))
        if (this.stateStore.length > 0){
          _validateObj.required = false
        }
        _validateObj.regex = this.validateObj.regex
        return _validateObj
      }
      return validateObj
    }
  }
}
</script>
<style lang="scss" scoped>
  .results-container{
    z-index: 100;
    width: 100%;
    background-color: #fff;
    overflow-y: auto;
    overflow-x: hidden;
    position: absolute;
    margin-top: -3px;
  }

  .results-container-chips {
    margin-top: -23px;
  }

  .has-result{
    border: 1px solid #949494;
  }

  .loading-small {
    margin-right: -35px;
  }

  .search{
    width: 100%;
    position: relative;
  }

  input{
    padding-right: 40px;
  }

  .md-chips {
    padding-right: 40px;
  }

  .md-chip {
    overflow: hidden;
    text-overflow: ellipsis;

    + .hide {
      display: none;
    }
  }
</style>
